import { render, staticRenderFns } from "./PDPProductName.vue?vue&type=template&id=8590d970&scoped=true"
import script from "./PDPProductName.vue?vue&type=script&lang=js"
export * from "./PDPProductName.vue?vue&type=script&lang=js"
import style0 from "./PDPProductName.vue?vue&type=style&index=0&id=8590d970&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8590d970",
  null
  
)

export default component.exports